import('@/common/fix')
import Vue from 'vue'
import App from './App.vue'
import router from './router'

//store
import store from './store'
import vuexMixin from './store/mixin'
Vue.mixin(vuexMixin)

// 引入vant
import Vant, { Toast, Dialog, Lazyload, ImagePreview } from 'vant'
import 'vant/lib/index.css'
Toast.allowMultiple()
Toast.setDefaultOptions('loading', { forbidClick: true, duration: 0 })
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$imagePreview = (images) => {
  ImagePreview({
    images,
    startPosition: 0,
    closeable: true
  })
}
Vue.prototype.$alertError = (error) => {
  console.error(error)
  Dialog.alert({
    title: '错误提示',
    message: error instanceof Error ? error.message : JSON.stringify(error)
  })
}
Vue.use(Vant)
Vue.use(Lazyload)

//request
import { post, get, sse } from '@/common/request'
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$sse = sse

//util
import util from '@/common/util.js'
Vue.prototype.$util = util

//mixin
import mixin from '@/common/mixin.js'
Vue.mixin(mixin)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
